import { type FC } from 'react';
import cn from 'classnames';
import { cubicBezier, motion } from 'framer-motion';

import css from './styles.module.scss';

const LightAnimation: FC = () => {
  const centerClass = 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2';

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        delay: 0.6,
        duration: 0.3,
        ease: cubicBezier(0.68, -0.55, 0.27, 1.55),
      }}
      className={cn('absolute w-full h-full', centerClass)}
    >
      <motion.span
        initial={{ rotate: 0, x: '-50%', y: '-50%' }}
        animate={{ rotate: 360, x: '-50%', y: '-50%' }}
        transition={{
          ease: 'linear',
          delay: 0.8,
          duration: 6,
          repeat: Infinity,
          repeatType: 'loop',
        }}
        className={cn(css.lightMask, centerClass)}
      ></motion.span>
      <span className={cn(css.ellipseGreen, centerClass)}></span>
      <motion.span
        style={{ width: 'var(--desktop-container-content-width)' }}
        className={cn(css.light, centerClass)}
      ></motion.span>
      <span className={css.ellipseYellow}></span>
    </motion.div>
    // <div className={cn(css.light, className)}>
    //   <div className={css.mask}>
    //     <motion.div
    //       animate={
    //         isAnimationStart
    //           ? {
    //               rotate: '360deg',
    //             }
    //           : undefined
    //       }
    //       transition={{
    //         duration: 10,
    //         ease: 'linear',
    //         repeat: Infinity,
    //         delay: 1.2,
    //       }}
    //       style={{
    //         backgroundImage: `image-set(url("${lightPng}") type("image/jpeg"), url("${lightWebp}") type("image/webp"))`,
    //       }}
    //       className={css.lightImage}
    //     ></motion.div>
    //   </div>
    // </div>
  );
};

export { LightAnimation };
